import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { layoutActions } from '../store';
import {
  Button, Grid, Typography, Box, Modal, Snackbar, makeStyles
} from '@material-ui/core';
import { Stack } from '@mui/material';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '480px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
};
const useStyles = makeStyles(() => ({
  buttons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > *': {
      flexBasis: '33%',
    },
  },
  formContainer: {
    display: 'block',
    width: '100%',
  }

}));

const StatusDateMessageModal = (props) => {
  const { open, setOpen, deviceId, message, history } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const user = useSelector((state) => state.session.user);

  const handleModalClose = () => {
    setOpen(false)
  }
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  ///////////////////////////////////////////////////////////////////////////////////



  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
  useEffect(() => {
    if (open) {
      dispatch(layoutActions.closeDeviceListMenu());
    }
  }, [open]);
  //////////////////////// app modal close feature //////////////////////////////////////////
  const appModalCloseTimestamp = useSelector((state) => state.layout.appModalCloseTimestamp);
  useEffect(() => {
    if (appModalCloseTimestamp) {
      setOpen(false)
    }
  }, [appModalCloseTimestamp]);
  ///////////////////////////////////////////////////////////////////////////////////////////

  return (
    <>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={modalStyle}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarOpen}
            onClose={() => { setSnackbarOpen(false) }}
            autoHideDuration={1500}
            message={toastMessage}
          />
          <div>
            <Typography variant="h6" component="h2">MooveTrax</Typography>
          </div>
          <Box sx={{ paddingTop: 16 }}>
            <div>
              <div style={{ maxHeight: 'calc(100vh - 255px)' }}>
                <Box sx={{ maxWidth: '100%', margin: 'auto' }}>
                  <div className={classes.formContainer}>
                    <Grid container justifyContent="space-between" spacing={2}>
                      <Grid item xs={12} sm={12}>
                        <Box style={{ whiteSpace: 'break-spaces' }}>{message}</Box>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <Button type="button" color="primary" variant="outlined" fullWidth onClick={() => setOpen(false)}>
                          Close
                        </Button>
                      </Grid>
                    </Grid>
                  </div>
                </Box>
              </div>
            </div>
          </Box>
        </Box>
      </Modal>
    </>
  )
}

export default StatusDateMessageModal;
